export default __webpack_public_path__ + "static/media/face_2_22.1e6d3cdf.png";